import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import CircularProgress from "@material-ui/core/CircularProgress";
import { Dialog, DialogContent, DialogTitle, IconButton, Box } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import AdminLayout from "./AdminLayout";
import CustomMuiDataTable from "src/Components/CustomMuiDataTable";

const AdminAskAi = () => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [imageDialogOpen, setImageDialogOpen] = useState(false);

  const getData = () => {
    setIsLoading(true);
    axios
      .get(`${process.env.REACT_APP_API}/admin/askAi/get`)
      .then((response) => {
        // Handle the response structure with success and data fields
        if (response.data.success && response.data.data) {
          setData(response.data.data);
        } else {
          setData(response.data);
        }
        setIsLoading(false);
      })
      .catch(() => {
        setIsLoading(false);
        toast.error("Error loading ask ai");
      });
  };

  useEffect(() => {
    getData();
  }, []);

  const handleImageClick = (imageUrl, imageName) => {
    console.log('Image URL:', imageUrl);
    console.log('Image Name:', imageName);
    setSelectedImage({ url: imageUrl, name: imageName });
    setImageDialogOpen(true);
  };

  const closeImageDialog = () => {
    setImageDialogOpen(false);
    setSelectedImage(null);
  };

  const columns = [
    { name: "id", label: "ID" },
    { 
      name: "user", 
      label: "User", 
      options: {
        customBodyRender: (value) => {
          if (value && value.first_name && value.last_name) {
            return `${value.first_name} ${value.last_name}`;
          }
          return "N/A";
        }
      }
    },
    { 
      name: "user", 
      label: "Email", 
      options: {
        customBodyRender: (value) => {
          return value && value.email ? value.email : "N/A";
        }
      }
    },
    { name: "description", label: "Description" },
    { 
      name: "original_image_name", 
      label: "Original Image", 
      options: {
        customBodyRender: (value) => {
          if (value) {
            const imageUrl = `${process.env.REACT_APP_UPLOADS}/AiImages/${value}`;
            return (
              <button
                onClick={() => handleImageClick(imageUrl, value)}
                style={{
                  backgroundColor: '#007bff',
                  color: 'white',
                  border: 'none',
                  padding: '4px 8px',
                  borderRadius: '4px',
                  cursor: 'pointer',
                  fontSize: '12px'
                }}
              >
                View Original
              </button>
            );
          }
          return "N/A";
        }
      }
    },
    { 
      name: "response_images", 
      label: "Response Images", 
      options: {
        customBodyRender: (value) => {
          if (value && value.length > 0) {
            return (
              <div style={{ display: 'flex', gap: '4px', flexWrap: 'wrap' }}>
                {value.map((img, index) => {
                  const imageUrl = `${process.env.REACT_APP_UPLOADS}/AiImages/${img.image_name}`;
                  return (
                    <button
                      key={index}
                      onClick={() => handleImageClick(imageUrl, img.image_name)}
                      style={{
                        backgroundColor: '#28a745',
                        color: 'white',
                        border: 'none',
                        padding: '4px 8px',
                        borderRadius: '4px',
                        cursor: 'pointer',
                        fontSize: '12px'
                      }}
                    >
                      Response {index + 1}
                    </button>
                  );
                })}
              </div>
            );
          }
          return "N/A";
        }
      }
    },
    { 
      name: "rating", 
      label: "Rating", 
      options: {
        customBodyRender: (value) => {
          return value ? `${value}/5` : "Not rated";
        }
      }
    },
    { 
      name: "review", 
      label: "Review", 
      options: {
        customBodyRender: (value) => {
          return value || "No review";
        }
      }
    },
    { 
      name: "created_at", 
      label: "Created At", 
      options: {
        customBodyRender: (value) => {
          return new Date(value).toLocaleString();
        }
      }
    }
  ];

  const options = {
    filter: true,
    rowsPerPage: 50,
    rowsPerPageOptions: [20, 50, 100],
    selectableRows: "none",
    textLabels: {
      body: {
        noMatch: isLoading ? <CircularProgress /> : "There is no matching data to display",
      },
    },
  };

  return (
    <AdminLayout>
      <div className="container">
        <CustomMuiDataTable title="Ask AI Data" data={data} columns={columns} options={options} />
        
        {/* Image Dialog */}
        <Dialog 
          open={imageDialogOpen} 
          onClose={closeImageDialog}
          maxWidth="md"
          fullWidth
        >
          <DialogTitle>
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <span>{selectedImage?.name}</span>
              <IconButton onClick={closeImageDialog} size="small">
                <CloseIcon />
              </IconButton>
            </Box>
          </DialogTitle>
          <DialogContent>
            {selectedImage && (
              <Box display="flex" justifyContent="center" alignItems="center">
                <img
                  src={selectedImage.url}
                  alt={selectedImage.name}
                  style={{
                    maxWidth: '100%',
                    maxHeight: '70vh',
                    objectFit: 'contain'
                  }}
                  onError={(e) => {
                    e.target.style.display = 'none';
                    e.target.nextSibling.style.display = 'block';
                  }}
                />
                <div style={{ display: 'none', textAlign: 'center', padding: '20px' }}>
                  <p>Image not found or failed to load</p>
                  <p style={{ fontSize: '12px', color: '#666' }}>{selectedImage.name}</p>
                </div>
              </Box>
            )}
          </DialogContent>
        </Dialog>
      </div>
    </AdminLayout>
  );
};

export default AdminAskAi;
